<template>
  <swiper :ref="reference" :options="options" @progress="onProgress" @touchEnd="onTouchEnd">
    <swiper-slide v-for="slide in slides" :key="slide.id">
      <bg-image :src="slide.background" class="slide-bg"></bg-image>

      <div class="slide-photos">
        <!-- <img v-for="(photo, index) in slide.photos" :key="index" :data-src="photo.low" :data-srcset="photo.high" class="slide-photo swiper-lazy" :alt="slide.year" data-swiper-parallax="-200">
        <div class="swiper-lazy-preloader"></div> -->
        <img v-for="(photo, index) in slide.photos" :key="index" :src="photo.high" class="slide-photo" :alt="slide.year" data-swiper-parallax="-200">
      </div>

      <div v-if="slide.year || slide.text" class="slide-year" data-swiper-parallax="-500">
        <p class="year" v-html="slide.year"></p>

        <span class="year-line"></span>

        <div class="sort-text">
          <p v-if="slide.sortText" v-html="slide.sortText"></p>
          <button v-if="slide.modal" class="btn-more" v-b-modal="slide.modal">read more</button>
        </div>
      </div>
    </swiper-slide>
  </swiper>

  <!-- <div class="navigation">
      <button type="button" class="button-prev" @click="prevSlide">
        <i class="icon-arrow-left"></i>
      </button>
      <button type="button" class="button-next" @click="nextSlide">
        <i class="icon-arrow-right"></i>
      </button>
    </div> -->
</template>

<script>
  import {
    Swiper,
    SwiperSlide
  } from 'vue-awesome-swiper'

  import gsap from 'gsap'

  let timelineLeft;
  // let reachedEnd = false;

  export default {
    components: {
      Swiper,
      SwiperSlide
    },
    props: {
      reference: {
        type: String,
        required: false,
        default: null
      },
      slides: {
        type: Array,
        required: true,
        default: []
      }
    },
    data() {
      return {
        hiddenPhotos: [],
        years: [],
        hiddenYears: [],
        showStartYear: true,
        options: {
          slidesPerView: 'auto',
          grabCursor: true,
          resistance: false,
          freeMode: true,
          freeModeMomentum: true,
          parallax: true,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          preloadImages: true,
          // lazy: {
          //   loadPrevNext: true,
          //   loadOnTransitionStart: true
          // }
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs[this.reference].$swiper
      }
    },
    methods: {
      nextSlide() {
        this.$refs[this.reference].$swiper.slideNext()
      },
      prevSlide() {
        this.$refs[this.reference].$swiper.slidePrev()
      },
      onProgress() {
        if (this.swiper.progress >= 1) {
          this.toggleEnd(true)
        } else {
          this.toggleEnd(false)
        }

        this.animateSlides()
      },
      onTouchEnd() {
        let checkMomentum = setInterval(() => {
          this.animateSlides(checkMomentum);
        }, 100);
      },
      toggleEnd(show) {
        gsap.to(document.querySelector(".timeline"), {
          duration: 1,
          width: show ? 'calc(80% - 260px)' : '90%'
        })

        gsap.to(document.querySelector(".timeline .end"), {
          duration: 1.5,
          opacity: show ? 1 : 0
        })
      },
      animateSlides(interval) {

        // Years toggle
        this.years.forEach(element => {
          var left = element.getBoundingClientRect().left;

          if (left + element.offsetWidth / 2 < timelineLeft) {
            gsap.to(element, {
              duration: 0.25,
              opacity: 0
            })
          } else {
            gsap.to(element, {
              duration: 0.25,
              opacity: 1
            })
          }
        });

        //Show hidden years
        this.hiddenYears.forEach((element, index) => {
          var left = element.getBoundingClientRect().left;

          if (left < window.innerWidth / 1.2) {
            gsap.to(element.children[0], {
              duration: 1,
              opacity: 1
            })

            gsap.to(element.children[1], {
              duration: 1,
              height: 44
            })

            if (element.children[2]) {
              gsap.to(element.children[2], {
                duration: 1,
                opacity: 1
              })
            }

            this.hiddenYears.splice(index, 1);
            this.years.push(element)
          }
        });

        //Show hidden photos
        this.hiddenPhotos.forEach((element, index) => {

          var left = element.getBoundingClientRect().left;

          if (left < window.innerWidth / 1.5) {
            gsap.to(element, {
              duration: 1,
              opacity: 1
            })

            this.hiddenPhotos.splice(index, 1);
          }
        });

        if (interval) {
          setTimeout(() => {
            clearInterval(interval)
          }, 1000)
        }

      }
    },
    mounted() {
      timelineLeft = document.querySelector(".timeline").getBoundingClientRect().left

      this.years = Array.from(document.querySelectorAll(".swiper-slide.swiper-slide-visible .slide-year"))

      this.hiddenYears = Array.from(document.querySelectorAll(".swiper-slide:not(.swiper-slide-visible) .slide-year"))

      this.hiddenYears.forEach(element => {
        Array.from(element.children).forEach((el, index) => {
          if (index === 1) {
            el.style.height = 0;
          } else {
            el.style.opacity = 0;
          }
        })
      })

      this.hiddenPhotos = Array.from(document.querySelectorAll(".swiper-slide:not(.swiper-slide-visible) .slide-photos"))

      this.hiddenPhotos.forEach(element => {
        element.style.opacity = 0;
      })
    }
  }
</script>

<style scoped lang="scss">
  @import 'src/sass/variables';
  @import 'node_modules/bootstrap/scss/vendor/rfs';

  .swiper-container {
    padding-top: 38%;

    .swiper-slide {
      position: relative;

      .slide-bg {
        width: 100%;
        height: 100%;
      }

      .slide-photos {
        position: absolute;
        z-index: 5;
        bottom: 20%;
        display: flex;
        align-items: center;
        height: 60%;

        .swiper-lazy-preloader {
          // var(--swiper-preloader-color, var(--swiper-theme-color))
          // border: 4px solid $secondary;
        }

        .slide-photo {
          // width: 100%;
          position: relative;
          max-height: 100%;
          margin-right: 0.8rem;
        }
      }

      .slide-year {
        position: absolute;
        bottom: 35.5%;
        z-index: 10;

        .year {
          color: $secondary;
          font-family: $font-family-monospace;
          @include font-size(4rem);
          position: relative;
        }

        .year-line {
          display: block;
          position: absolute;
          top: 100%;
          left: 50%;
          width: 2px;
          height: 44px;
          background-color: $secondary;
        }

        .sort-text {
          position: absolute;
          top: calc(100% + 20px);
          left: calc(50% + 12px);

          p {
            @include font-size(0.8125rem);
            white-space: nowrap;
            margin-bottom: 0.7rem;
          }

          .btn-more {
            @include font-size(0.6875rem);
            background: rgba($white, 0.36);
            color: $white;
            z-index: 15;
            font-family: "corundum-text", serif;
            letter-spacing: 0.06rem;
            padding: 5px;
            white-space: nowrap;
            transition: all 250ms ease-in-out;

            &:hover {
              color: $red;
              background: rgba($white, 1);
            }
          }
        }
      }

      &:nth-child(1) {
        width: 18vw;

        .slide-photos {
          left: 45%;
          z-index: 10;
          width: 73%;
        }

        .slide-year {
          left: 30%;

          .year-line {
            display: none;
          }

          .sort-text {
            left: 0%;
          }
        }
      }

      &:nth-child(2) {
        width: 62vw;

        .slide-photos {
          bottom: 13%;
          left: 20%;
          width: 30.5%;
        }

        .slide-year {
          left: 10%;
        }
      }

      &:nth-child(3) {
        width: 74vw;

        .slide-photos {
          // bottom: 30%;
          left: -25%;
          width: 26%;
        }

        .slide-year {
          left: -45%;
        }
      }

      &:nth-child(4) {
        width: 66vw;

        .slide-photos {
          left: -10%;
          width: 63%;
        }

        .slide-year {
          left: -15%;
        }
      }

      &:nth-child(5) {
        width: 79vw;

        .slide-photos {
          left: 5%;
          width: 77%;
        }

        .slide-year {
          left: -13%;
        }
      }

      &:nth-child(6) {
        width: 95vw;

        .slide-photos {
          bottom: 15%;
          left: 5%;
          width: 63%;
        }

        .slide-year {
          left: 0%;
        }
      }

      &:nth-child(7) {
        width: 103vw;

        .slide-photos {
          bottom: 15%;
          left: 5%;
          width: 41.5%;
        }

        .slide-year {
          left: 0%;
        }
      }
    }
  }

  // LG
  @media only screen and (max-width: 991px) {
    .swiper-container {
      padding-top: 58%;

      .swiper-slide {
        .slide-year {
          bottom: 37.5%;
        }

        &:nth-child(1) {
          width: 40vw;
        }

        &:nth-child(3) {
          width: 90vw;
        }

        &:nth-child(4) {
          width: 103vw;
        }

        &:nth-child(5) {
          width: 129vw;
        }

        &:nth-child(6) {
          width: 150vw;
        }

        &:nth-child(7) {
          width: 203vw;
        }
      }
    }
  }

  @media only screen and (max-width: 575px) {
    .swiper-container {
      padding-top: 90%;

      .swiper-slide {
        &:nth-child(1) {
          width: 60vw;
        }
      }
    }
  }
</style>